import { MultiCountrySurvey } from '../interface/multi-country.interface';
import { Constants as CreateSurveyConstants } from '../../../../../shared/constants/create-survey.constants';

export class MCTemplateSelectionDataMapper {
  constructor(
    private readonly _surveys: MultiCountrySurvey[],
    private readonly _currentSurveyId: number,
    private readonly _templateLocalization: string
  ) {}

  public map(): { modal_text: string; delete_survey_id?: number } {
    if (!this._exists()) {
      return {
        modal_text:
          CreateSurveyConstants.CONFIRM_MODAL_TEXT.TEMPLATE_SELECTION_FOR_MC
            .LOCALE_NOT_EXIST_IN_MC_SURVEYS,
      };
    }

    const deleteSurveyId = this._surveyId();

    if (this._same()) {
      return {
        modal_text:
          CreateSurveyConstants.CONFIRM_MODAL_TEXT.TEMPLATE_SELECTION_FOR_MC
            .SAME_LOCALE_AS_SELECTED,
        delete_survey_id: deleteSurveyId,
      };
    }

    return {
      modal_text:
        CreateSurveyConstants.CONFIRM_MODAL_TEXT.TEMPLATE_SELECTION_FOR_MC
          .NOT_SAME_LOCALE_AS_SELECTED,
      delete_survey_id: deleteSurveyId,
    };
  }

  private _exists(): boolean {
    return this._surveys.some(
      (s) => s.survey_localization === this._templateLocalization
    );
  }

  private _same(): boolean {
    return this._surveys.some(
      (s) =>
        s.survey_localization === this._templateLocalization &&
        s.survey_id === Number(this._currentSurveyId)
    );
  }

  private _surveyId(): number {
    return this._surveys.find(
      (s) => s.survey_localization === this._templateLocalization
    )!.survey_id;
  }
}
